// This file contains text constants used in several modules across the application.
// Add text constants that are meant to be used in multiple modules here.
// For example, cross-sell text constants, common text or error messages, etc.

import { RewardsAccount, RewardsCurrency } from "redmond";

// Luxury Promotions marketting / awareness
export const COMPLIMENTARY_NIGHT_PROMOTION_TITLE = "Complimentary fourth night";
export const COMPLIMENTARY_NIGHT_PROMOTION_DESCRIPTION =
  "Extend your escape when you book an eligible stay of at least four nights at select Premier and Lifestyle Collection Hotels.";
export const COMPLIMENTARY_NIGHT_PROMOTION_BUTTON_TEXT = "Explore properties";

/**
 * Generates a JSX element for displaying earn rate information.
 *
 * @param rewardsAccount - The rewards account containing earn rate multipliers
 * @param currency - The rewards currency type ("Miles" | "Cash"). Must match RewardsCurrency type.
 * @param uiVariant - The type of travel service ("hotels", "cars", or "flights")
 * @returns A JSX element displaying the earn rate message, or undefined if no earn rate exists
 *
 * @example
 * ```tsx
 * const earnTag = getEarnTag(rewardsAccount, "Miles", "hotels");
 * // Returns JSX like: <span>Earn <span className="font-bold">5X Miles</span> on hotels</span>
 * ```
 */
export const getEarnTag = (
  rewardsAccount: RewardsAccount,
  currency: RewardsCurrency,
  uiVariant: "hotels" | "cars" | "flights"
): JSX.Element | undefined => {
  const earnRateMap = {
    hotels: rewardsAccount.earn.hotelsMultiplier,
    cars: rewardsAccount.earn.carsMultiplier,
    flights: rewardsAccount.earn.flightsMultiplier,
  };
  const earnRate = earnRateMap[uiVariant];
  const multiplierMap = {
    Miles: "X",
    Cash: "%",
  };
  const multiplier = multiplierMap[currency];

  if (earnRate) {
    return (
      <span>
        Earn{" "}
        <span className="font-bold">
          {earnRate}
          {multiplier} {currency}
        </span>{" "}
        on {uiVariant}
      </span>
    );
  }

  return undefined;
};
